import React, { useState } from 'react';
import DeleteConfirm from '../../../components/DeleteConfirm';
import ENUMS from '../../../enums';
import { enumHelper } from '../../../utils';

export default props => {
  const [displayDeleteConfirm, setDisplayDeleteConfirm] = useState(false);
  const [selectedItemKeyForDelete, setSelectedItemKeyForDelete] = useState(false);
  const [selectedItemTitleForDelete, setSelectedItemTitleForDelete] = useState('');

  const sortByDay = (a, b) => {
    const sorter = {
      sat: 0,
      sun: 1,
      mon: 2,
      tue: 3,
      wed: 4,
      thu: 5,
      fri: 6
    };
    let day1 = a.day.toLowerCase();
    let day2 = b.day.toLowerCase();
    return sorter[day1] - sorter[day2];
  };

  const deleteAlreadySelectedItem = () => {
    props.deleteWorkingHourItem(selectedItemKeyForDelete);
    setDisplayDeleteConfirm(false);
    setSelectedItemKeyForDelete(null);
  };

  const onDeleteItem = ({ itemKey, dayTitle, fromTime, toTime }) => {
    setDisplayDeleteConfirm(true);
    setSelectedItemKeyForDelete(itemKey);
    setSelectedItemTitleForDelete(`ساعت کاری ${fromTime} تا ${toTime} روز ${dayTitle}`);
  };

  const onEditItem = itemKey => {
    props.displayEditWorkingHourItemModal(itemKey);
  };

  const closeDeleteWorkingHourItemModal = () => {
    setDisplayDeleteConfirm(false);
    setSelectedItemKeyForDelete(null);
  };

  return (
    <div className={props.className}>
      <table className="table table-hover table-bordered table-striped" width="100">
        <thead>
          <tr>
            <th className="text-center text-muted">{locales('fields.row')}</th>
            <th className="text-center text-muted">{locales('fields.week.day')}</th>
            <th className="text-center text-muted">{locales('fields.start.time')}</th>
            <th className="text-center text-muted">{locales('fields.end.time')}</th>
            <th colSpan="2"></th>
          </tr>
        </thead>
        <tbody>
          {props.workingHours &&
            props.workingHours.sort(sortByDay).map((item, ix) => {
              return (
                <tr key={item.day + '_' + item.fromTime}>
                  <td className="text-center text-muted">{ix + 1}</td>
                  <td className="text-center text-muted">
                    {enumHelper.convertEnumValueToTitle(ENUMS.WEEK_DAYS.list, item.day)}
                  </td>
                  <td className="text-center text-muted">{item.fromTime}</td>
                  <td className="text-center text-muted">{item.toTime}</td>
                  <td className="text-center">
                    <i onClick={e => onEditItem(item.itemKey)} className="fal fa-edit pointer" />
                  </td>
                  <td className="text-center">
                    <i
                      onClick={e =>
                        onDeleteItem({
                          itemKey: item.itemKey,
                          dayTitle: enumHelper.convertEnumValueToTitle(ENUMS.WEEK_DAYS.list, item.day),
                          fromTime: item.fromTime,
                          toTime: item.toTime
                        })
                      }
                      className="fal fa-trash pointer"
                    />
                  </td>
                </tr>
              );
            })}
          <tr>
            <td colSpan="5"></td>
            <td>
              <i
                className="fal fa-plus-circle p-1 pointer"
                onClick={props.displayAddWorkingHourModal}
                title={locales('labels.add.new.working.hour')}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {displayDeleteConfirm && (
        <DeleteConfirm
          isOpen={displayDeleteConfirm}
          itemGroupTitle={locales('titles.working.hour')}
          itemKey={selectedItemKeyForDelete}
          itemTitle={selectedItemTitleForDelete}
          onConfirm={deleteAlreadySelectedItem}
          closeModal={closeDeleteWorkingHourItemModal}
        />
      )}
    </div>
  );
};
